import { loadingRoles, setSelectedFuncionalities, setDataListas, getRoles } from "../../General/actions";
import { deleteRol, createRol, updateRol } from "../../../../../services/rolesApi";
import { openCloseToast } from "../../../../Global/actions";
import { getRolFunctionality, createRolFunctionalities, deleteRolFunctionalities, getAllFunctionalities } from "../../../../../services/funcionalidadesApi";


// getRoles,

export const doDeleteRol = (idRol) => async (dispatch) => {
  dispatch(loadingRoles(true));
  try {
    const result = await deleteRol(idRol);
    if (result.status === 200) {
      dispatch(getRoles(false));
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Rol eliminado con éxito",
        typeStyle: "success",
        displayTime: 5000
      }));
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al eliminar el rol",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al eliminar el rol",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loadingRoles(false));
};

export const doCreateRol = (saveEvent) => async (dispatch, getState) => {
  dispatch(loadingRoles(true));
  try {
    const funcionalidades = getState().mantenedores.selectedFuncionalities;
    if (!funcionalidades.length) {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Debe agregar funcionalidades para crear un Rol nuevo",
        typeStyle: "warning",
        displayTime: 5000
      }));
    } else {
      const result = await createRol(saveEvent.data.IdProfile, saveEvent.data.Name, saveEvent.data.Description, !!saveEvent.data.AdminAchsOffices);
      if (result.status === 200) {
        const rol = await result.json();
        const req = await createRolFunctionalities(rol.IdRol, funcionalidades);
        if (req.status === 200) {
          dispatch(getRoles(false));
          dispatch(openCloseToast({
            isToastOpen: true,
            msgToast: "Rol creado con éxito",
            typeStyle: "success",
            displayTime: 5000
          }));
        } else {
          dispatch(openCloseToast({
            isToastOpen: true,
            msgToast: "Error al asignar las funcionalidades",
            typeStyle: "error",
            displayTime: 5000
          }));
        }
      } else {
        const resulroles = await result.json();
        if (result.status === 403) {
          dispatch(openCloseToast({
            isToastOpen: true,
            msgToast: resulroles.Message,
            typeStyle: "warning",
            displayTime: 5000
          }));
        } else {
          dispatch(openCloseToast({
            isToastOpen: true,
            msgToast: resulroles.Message,
            typeStyle: "error",
            displayTime: 5000
          }));
        }
      }
    }
  } catch {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente más tarde.",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loadingRoles(false));
};

export const doUpdateFunctionalities = (rowId, functionalityIds) => async (dispatch) => {
  dispatch(loadingRoles(true));
  try {
    const result = await deleteRolFunctionalities(rowId);
    if (result.status === 200) {
      const create = await createRolFunctionalities(rowId, functionalityIds);
      if (create.status === 200) {
        dispatch(openCloseToast({
          isToastOpen: true,
          msgToast: "Funcionalidades actualizadas",
          typeStyle: "success",
          displayTime: 5000
        }));
      }
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al actualizar las funcionalidades",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al editar las funcionalidades del rol",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loadingRoles(false));
};

export const doUpdateRol = (data) => async (dispatch, getState) => {
  // dispatch(loadingRoles(true));
  try {
    const result = await updateRol(data.Id, data.IdProfile, data.Name, data.Description, !!data.AdminAchsOffices);
    if (result.status === 200) {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Rol editado con éxito",
        typeStyle: "success",
        displayTime: 5000
      }));
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al crear el rol",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al editar el rol",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  // dispatch(loadingRoles(false));
};

export const doGetAllFunctionalities = () => async (dispatch) => {
  try {
    const request = await getAllFunctionalities();
    if (request.status === 200) {
      const result = await request.json();
      dispatch(setDataListas({
        functionalities: result.Data,
      }));
    }
  } catch (e) {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al obtener las funcionalidades",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
};

export const getRolFuncionalities = (idRol) => async (dispatch) => {
  try {
    const request = await getRolFunctionality(idRol);
    if (request.status === 200) {
      const result = await request.json();
      if (result.Success) {
        const ids = [];
        result.Data.forEach((id) => {
          ids.push(id.IdFunctionality);
        });
        dispatch(setSelectedFuncionalities(ids));
      } else {
        dispatch(setSelectedFuncionalities([]));
      }
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al obtener las funcionalidades",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al obtener las funcionalidades",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
};
